module.exports = __webpack_public_path__ + "static/media/Img_Inicio.71e42185.jpg";